import React from 'react';
import raamLogo from '../assets/image6.png';
import qlikLogo from '../assets/Qlik-Logo_WHITE.png';

const Footer = () => (
  <div className="raam-footer">
    <div className="container">
      <div className="row pb-3">
        <div className="col-md-3">
          <a href="https://www.raceacrossamerica.org/"><img src={raamLogo} alt="raam-logo" className="raam-logo" /></a>
        </div>
        <div className="col-md-6 text-center">
          Data courtesy of Race Across America Roll Call, 1982-2019 by Dex Tooke. More about Dex and Ultracycling at
          {' '}
          <a href="https://www.ultradex.net/resume">Unfinished Business</a>
          {' '}
and
          {' '}
          <a href="https://www.ultradex.net/ncom-home">NCOM</a>
        </div>
        <div className="col-md-3 text-right">
          <a href="https://www.qlik.com"><img src={qlikLogo} alt="qlik-logo" className="qlik-logo" /></a>
        </div>
        <div className="col-md-12 text-center">
          View RAAM rider Dave Haase’s fan experience page
          {' '}
          <a href="http://www.davehaase.com/">here</a>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12 text-center">
          1993-2018 Qlik Tech Inc. All rights reserved.
        </div>
      </div>
    </div>
  </div>
);

export default Footer;
